import "../Slider/Slider.css";
import { Link } from "react-router-dom";

import SliderImg1 from '../images/gatisheel-slider1.webp';
import SliderImg2 from '../images/dashboard.png';
import homeImg1 from '../images/gatisheel1.webp';
import GatisheelFooterLogo from '../images/gatisheel_logo.png';
import partnerLogo1 from '../images/hfpc.png';
import partnerLogo2 from '../images/Environomics_Logo.png';
import partnerLogo3 from '../images/Unimart_Logo.png';



export default function Slider() {
    return (
        <>
			<div className="containerSlider">
				<div id="carouselExampleDark" className="carousel slide">
					<div className="carousel-indicators">
						<button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
						<button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
					</div>
					<div className="carousel-inner">
						<div className="carousel-item active" data-bs-interval="1000">
							<img src={SliderImg1} className="d-block w-100 custom-display" alt="Gatisheel slider1" />
							<div class="carousel-caption d-none d-md-block">
								<h5 className="custom1-h5">
									Our vision is to create energy independent farms
								</h5>
								<a href=" ">
									<Link to="/honey">
										<button className="custom-button">
											{" "}
											Learn More
										</button>
									</Link>
								</a>
							</div>
						</div>

						<div className="carousel-item" data-bs-interval="2000">
							<img src={SliderImg2} className="d-block w-100 custom-display" alt="Gatisheel slider2" />

							<div className="carousel-caption d-none d-md-block">
								{/* <h5 className="custom2-h5">DASHBOARD</h5> */}
								<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
								<br></br><br></br><br></br><br></br><br></br><br></br><br></br>
								<a href=" ">
									<Link to="/irrigation">
										<button className="custom-button2" style={{textAlign: 'right'}}>
											{" "}
											Learn about our work
										</button>
									</Link>
								</a>
							</div>
						</div>
					</div>
					<button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
						<span className="carousel-control-prev-icon" aria-hidden="true"></span>
						<span className="visually-hidden">Previous</span>
					</button>
					<button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
						<span className="carousel-control-next-icon" aria-hidden="true"></span>
						<span className="visually-hidden">Next</span>
					</button>
				</div>					
			</div>

			{/* Why Gatisheel */}
			<div className="container secWhyGatisheel py-5">
				<h3 className="title mb-3">Why Gatisheel?</h3>
				<div className="row">
					<div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 div_img">
						<img src={homeImg1} className="img-fluid" alt="Why Gatisheel" loading="lazy" width="100%" height="auto" />
					</div>

					<div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 right_div">
						<div className="row row-cols-1 row-cols-md-2 g-4">
							<div className="col">
								<div className="card h-100">
									<div className="row p-4">
										<div className="col-9">
											<h5 className="wcy_subtitle">Authorized Dealer</h5>
											<div className="title_underscore2"></div>
										</div>
										<div className="col-3 text-end">
											{/* <i className="fa-solid fa-tachograph-digital text-primary"></i> */}
											<img src={GatisheelFooterLogo} style={{ width: "32px" }} alt="Gatisheel" />
										</div>
									</div>
									<div className="card-body px-4 pb-4">
										<p className="card-text">
											We believe in expanding our reach with the expertise of our channel partners and dealers. IF you are interested in selling our products, click on <a href = "https://wa.me/+919518802185">Connect </a> and Gatisheel associate will assist you on the same.
										</p>
										<a href=" ">Connect ➞</a>
									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="row p-4">
										<div className="col-9">
											<h5 className="wcy_subtitle">Genuine Product</h5>
											<div className="title_underscore2"></div>
										</div>
										<div className="col-3 text-end">
											<img src={GatisheelFooterLogo} style={{ width: "32px" }} alt="Gatisheel" />
										</div>
									</div>
									<div className="card-body px-4 pb-4">
										<p className="card-text">
										Gatisheel believes in making world class products. All our vendors and partners are certified by ISO and relevant certification authority.
										</p><br></br><br></br>
										<a href = "https://wa.me/+919518802185">Quality ➞</a>
									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="row p-4">
										<div className="col-9">
											<h5 className="wcy_subtitle">100% Replacement on Damage Product</h5>
											<div className="title_underscore2"></div>
										</div>
										<div className="col-3 text-end">
											<img src={GatisheelFooterLogo} style={{ width: "32px" }} alt="Gatisheel" />
										</div>
									</div>
									<div className="card-body px-4 pb-4">
										<p className="card-text">
											For first 15 days, if you found any issues with the product, it will be replaced immediately. For first 12 months, product is warranted against any defects. <a href = "https://wa.me/+919518802185">Contact Here </a> can help you to connect with the Gatisheel associate. 
										</p>
										<a href ="https://wa.me/+919518802185">Raise it ➞</a>
									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="row p-4">
										<div className="col-9">
											<h5 className="wcy_subtitle">Service Available on 24/7</h5>
											<div className="title_underscore2"></div>
										</div>
										<div className="col-3 text-end">
											<img src={GatisheelFooterLogo} style={{ width: "32px" }} alt="Gatisheel" />
										</div>
									</div>
									<div className="card-body px-4 pb-4">
										<p className="card-text"><br></br>
											Click on <a href = "https://wa.me/+919518802185">Enquire now </a> and submit your query, service technician will contact you within next 12 hours. You can leave your queries anytime during the day 24X7.
										</p><br></br>
										<a href ="https://wa.me/+919518802185">Enquiry ➞</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Why Gatisheel End */}

			{/* Product */}
			<div className="container secProduct py-5">
				<h3 className="title mb-3">Our Products</h3>
				<div className="row">
					<div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 div_img">
						<img src={homeImg1} className="img-fluid" alt="Why Gatisheel" loading="lazy" width="100%" height="auto" />
					</div>
					<div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 div_img">
						<img src={homeImg1} className="img-fluid" alt="Why Gatisheel" loading="lazy" width="100%" height="auto" />
					</div>

					
				</div>
			</div>
			{/* Product */}

			{/* Product Video */}
			<div className="container secProductVideo py-5">
				<h3 className="title mb-3">Product Installation</h3>
				<div className="row">
					<div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="row row-cols-1 row-cols-md-2 g-4">
							<div className="col">
								<div className="card h-100">
									<div className="card-body">
										<div class="ratio ratio-16x9 m-0 p-0">
											<iframe class="No_Name" src="https://www.youtube.com/embed/velOf4Jizxo?si=5Uda1gkFwTQuQeFF" title="YouTube Video Player" allowfullscreen></iframe>
										</div>

										{/* <div class="embed-responsive embed-responsive-21by9">
											<video class="embed-responsive-item" muted="" autoplay="" loop="" src="https://storage.googleapis.com/cms-storage-bucket/029113ae2cbbcf9493fe.mp4" type="video/mp4" width="100%">
												<img src="https://storage.googleapis.com/cms-storage-bucket/a667e994fc2f3e85de36.png" alt="Fast" />
											</video>
										</div> */}
									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="card-body">
										<div class="ratio ratio-16x9 m-0 p-0">
											<iframe class="No_Name2" src="https://www.youtube.com/embed/RAlnjQLqACc?si=A0-wE9MTp06UTOgr" title="YouTube Video Player" allowfullscreen></iframe>
										</div>

										{/* <div class="ratio ratio-16x9">
											<iframe src="https://www.youtube.com/embed/velOf4Jizxo?si=5Uda1gkFwTQuQeFF" title="YouTube video" allowfullscreen></iframe>
										</div> */}

									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="card-body">
										<div class="ratio ratio-16x9 m-0 p-0">
											<iframe class="No_Name2" src="https://www.youtube.com/embed/7Rv0HK4JZow?si=BegCC1M1480YcF_X" title="YouTube Video Player" allowfullscreen></iframe>
										</div>

										{/* <div class="ratio ratio-16x9">
											<iframe src="https://www.youtube.com/embed/velOf4Jizxo?si=5Uda1gkFwTQuQeFF" title="YouTube video" allowfullscreen></iframe>
										</div> */}

									</div>
								</div>
							</div>




						</div>
					</div>					
				</div>
			</div>
			{/* Product Video */}

			{/* Partners */}
			<div className="container secPartners py-5">
				<h3 className="title mb-3">Gatisheel’s Partners</h3>
				<div className="row">
					<div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="row row-cols-1 row-cols-md-4 g-4">
							<div className="col">
								<div className="card h-100">
									<div className="card-body">
										<img src={partnerLogo1} alt="" />
									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="card-body">
										<img src={partnerLogo2} alt="" />
									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="card-body">
										<img src={partnerLogo3} alt="" />
									</div>
								</div>
							</div>

							<div className="col">
								<div className="card h-100">
									<div className="card-body">
										<img src={partnerLogo1} alt="" />
									</div>
								</div>
							</div>
						</div>
					</div>					
				</div>
			</div>
			</>
    );
}
